import { Privilege } from '../../clients/aasServerClient.generated';
import { RootState } from '../store';

export const getTableUsers = (state: RootState) => state.users.table;

export const getUserName = (state: RootState) => {
    return (id: string) => {
        const user = state.users.all.find((e) => e.id === id);
        if (user) {
            return user.email || user.username || user.id;
        } else {
            return '...'; // id;
        }
    };
};

export const userOptions = (state: RootState) => {
    return state.users.all.map((user) => {
        return {
            label: user.email || user.username || user.id,
            value: user.id,
        };
    });
};

export const isSuperAdmin = (state: RootState) => {
    return (id: string) => {
        const user = state.users.table.find((e) => e.id === id);
        if (user) {
            return user.privileges?.find((p) => p.name === 'SUPER_ADMIN') !== undefined;
        } else {
            return false;
        }
    };
};

export const isUserAdmin = (state: RootState) => {
    return (id: string) => {
        const user = state.users.table.find((e) => e.id === id);
        if (user) {
            return user.privileges?.find((p) => p.name === 'USER_ADMIN') !== undefined;
        } else {
            return false;
        }
    };
};

export const isWorkspaceAdmin = (state: RootState) => {
    return (id: string) => {
        const user = state.users.table.find((e) => e.id === id);
        if (user) {
            return user.privileges?.find((p) => p.name === 'WORKSPACE_ADMIN') !== undefined;
        } else {
            return false;
        }
    };
};

export const isOldUser = (state: RootState) => {
    return (id: string) => {
        const user = state.users.table.find((e) => e.id === id);
        if (user) {
            return user.is_old_user;
        } else {
            return false;
        }
    };
};

export const getSingleUser = (state: RootState) => state.users.singleUser;